import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { NotificationContainer, NotificationManager } from 'react-notifications';

import './AccessCodePopupWrapper.css';
import '../../../lib/css/react-notifications.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '5px',
  },
};

function AccessCodePopup() {
  const [modalIsOpen, setIsOpen] = useState(true);
  const [accessCode, setAccessCode] = useState();

  const checkAccessCode = (e) => {
    e.preventDefault();

    const webAPI = process.env.REACT_APP_MINERVA_TOOL_API;
    const password = accessCode;

    fetch(webAPI, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ body: {password} })
    }).then((response) => {
      response.json().then((data) => {
        if (data.isValid) {
          setIsOpen(false);
          sessionStorage.setItem('hasAuthorization', 'isValid');
        } else {
          NotificationManager.error('Sorry code is not valid. Please try again.', '', 5000);
        }
      }) 
    }).catch((error) => {
      console.log('error thrown', error);
    });
  }

  return (
    <div className="popup-container">
      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        contentLabel={"Password access code modal"}
      >
        <div className="modal-content">
          <h2>Please enter your password to access this page</h2>
          <form onSubmit={(e) => checkAccessCode(e)}>
            <div className="input-textbox">
              <input
                type="text"
                name="validation-code"
                onChange={(e) => setAccessCode(e.target.value)}
                defaultValue={accessCode}
              />
            </div>
            <button className="submit-button" onClick={(e) => checkAccessCode(e)}>Submit</button>
          </form>
        </div>
      </Modal>
      <NotificationContainer />
    </div>
  )
}

export default AccessCodePopup;


// WEBPACK FOOTER //
// ./src/components/elements/AccessCodePopup/index.js